import secureImg from '../../assets/images/result/attachment/Secure.jpg';
import anxiousImg from '../../assets/images/result/attachment/Anxious.jpg';
import avoidantImg from '../../assets/images/result/attachment/Avoidant.jpg';
import disorganizedImg from '../../assets/images/result/attachment/Disorganized.jpg';

export const attachmentDescriptions = {
  secure: {
    title: "안정형 애착",
    subtitle: "자기긍정 / 타인긍정",
    image: secureImg,
    perspectives: {
      self: [
        "나는 가치 있는 사람이다",
        "나의 감정은 중요하다",
        "실수해도 괜찮다",
        "도움을 요청해도 된다"
      ],
      others: [
        "대체로 타인을 신뢰할 수 있다",
        "관계는 상호적이어야 한다",
        "타인의 관점도 존중한다",
        "거절도 받아들일 수 있다"
      ]
    },
    background: "어린 시절 양육자로부터 일관된 돌봄과 지지를 받았습니다. 자신의 요구가 적절히 충족되었고, 안전 기지로서의 양육자를 경험했습니다. 이를 통해 자신과 타인에 대한 긍정적인 내적 작동 모델을 형성했습니다.",
    relationships: "갈등 상황에서도 건설적인 대화가 가능하며, 친밀감과 독립성의 균형을 잘 유지합니다. 감정 표현이 자연스럽고 진실하며, 상대방의 필요를 잘 알아차리고 존중하는 특성을 보입니다.",
    commonPhrases: [
      "네 이야기를 들려줘서 고마워",
      "내 생각은 이런데, 너는 어떻게 생각해?",
      "도움이 필요하면 언제든 말해줘",
      "서로 이해하려고 노력해보자"
    ]
  },
  anxious: {
    title: "불안형 애착",
    subtitle: "자기부정 / 타인긍정",
    image: anxiousImg,
    perspectives: {
      self: [
        "나는 충분히 좋은 사람이 아닐 수 있다",
        "나의 요구가 과도할 수 있다",
        "실수하면 버림받을 것 같다",
        "혼자서는 불안하다"
      ],
      others: [
        "타인의 인정이 매우 중요하다",
        "타인은 나보다 더 가치있는 존재다",
        "타인의 사랑이 필요하다",
        "거절당하면 견디기 어렵다"
      ]
    },
    background: "어린 시절 양육자로부터 일관성 없는 반응을 경험했습니다. 때로는 과도하게 개입하고, 때로는 무관심한 양육 패턴으로 인해 관계에서의 불안감이 형성되었습니다.",
    relationships: "관계에서 과도한 확신과 안정감을 추구하며, 상대방의 작은 변화에도 민감하게 반응합니다. 버림받는 것에 대한 두려움이 크고, 관계에 과도하게 매달리는 경향이 있으며, 자신의 가치를 타인의 반응에 많이 의존합니다.",
    commonPhrases: [
      "나를 떠나지 않을 거지?",
      "내가 너무 부담스러울까봐 걱정돼",
      "정말 나를 사랑하는 게 맞아?",
      "내가 잘못한 게 있다면 말해줘"
    ]
  },
  avoidant: {
    title: "회피형 애착",
    subtitle: "자기긍정 / 타인부정",
    image: avoidantImg,
    perspectives: {
      self: [
        "나는 혼자가 편하다",
        "나는 독립적인 사람이다",
        "감정 표현은 약점이 될 수 있다",
        "자립심이 중요하다"
      ],
      others: [
        "타인에게 의존하면 위험하다",
        "깊은 관계는 부담스럽다",
        "타인은 나를 실망시킬 수 있다",
        "거리를 두는 것이 안전하다"
      ]
    },
    background: "어린 시절 양육자로부터 정서적 거리감이나 거절을 경험했습니다. 자신의 요구나 감정이 적절히 수용되지 않아 타인과의 친밀감을 경계하게 되었습니다.",
    relationships: "친밀한 관계 형성을 어려워하며 정서적 거리두기를 선호합니다. 자신의 감정과 필요를 표현하는 것을 불편해하고, 타인에 대한 의존이나 깊은 유대 관계를 형성하는 것을 꺼립니다.",
    commonPhrases: [
      "나는 혼자서도 잘 해낼 수 있어",
      "그렇게까지 친해질 필요는 없을 것 같아",
      "좀 더 시간이 필요해",
      "너무 가깝게 지내는 건 부담스러워"
    ]
  },
  disorganized: {
    title: "혼란형 애착",
    subtitle: "자기부정 / 타인부정",
    image: disorganizedImg,
    perspectives: {
      self: [
        "나는 안전하지 않다",
        "나는 혼란스럽다",
        "내 감정을 신뢰할 수 없다",
        "나는 결함이 있는 사람이다"
      ],
      others: [
        "타인은 위험할 수 있다",
        "관계는 예측할 수 없다",
        "누구도 믿을 수 없다",
        "친밀함은 두렵다"
      ]
    },
    background: "어린 시절 양육자로부터 심각한 비일관성이나 외상적 경험을 했습니다. 보호받아야 할 대상이 오히려 두려움의 대상이 되는 모순된 경험으로 인해 복잡한 애착 패턴이 형성되었습니다.",
    relationships: "관계에서 강한 양가감정을 경험하며, 친밀함을 원하면서도 동시에 두려워합니다. 감정 조절이 어렵고 관계 패턴이 불안정하며, 타인을 신뢰하거나 안정적인 관계를 유지하는 것에 큰 어려움을 겪습니다.",
    commonPhrases: [
      "가까워지고 싶지만 동시에 무서워",
      "이 관계가 진짜일까?",
      "믿고 싶은데 믿을 수가 없어",
      "더 이상 상처받고 싶지 않아"
    ]
  }
}; 